import { EndpointBuilder } from "@reduxjs/toolkit/query";
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from "@reduxjs/toolkit/query";
import { BaseQueryFn } from "@reduxjs/toolkit/query";
import { MeterProfileDataNestedResponse } from "../../types";

export const NamePlateEndPoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    "hesApi"
  >
) => ({
  getNamePlateDetailData: builder.query<
    MeterProfileDataNestedResponse,
    { searchQuery: string }
  >({
    query: ({ searchQuery }) => ({
      url: `/push-data/nameplate${searchQuery}`,
      method: "GET",
    }),
    keepUnusedDataFor: 0,
  }),
});
